import Fragment from './Fragment.js'
import Card from './Card.js'
import ManagedRounds from './ManagedRounds.js'

export default {
    card: Card,
    managedRounds: ManagedRounds,
    fragment: Fragment,
}
